import { render } from "./HeaderSection.vue?vue&type=template&id=2e678a5e&scoped=true"
import script from "./HeaderSection.vue?vue&type=script&lang=js"
export * from "./HeaderSection.vue?vue&type=script&lang=js"

import "./HeaderSection.vue?vue&type=style&index=0&id=2e678a5e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e678a5e"]])

export default __exports__